"use client";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useState } from "react";
import Next from "../../../public/homePage/next.svg";
import Prev from "../../../public/homePage/prev.svg";
import Link from "next/link";

const AIcrousel = (props: any) => {
  const { activeNav, initialScroll } = props;
  const [clickedArrow, setClickedArrow] = useState("");

  const SampleNextArrow = (props: any) => {
    const { className, style, onClick, clickedArrow } = props;

    return (
      <Next
        className={
          className +
          ` productivity-next ${
            clickedArrow === "right" ? "carousel-btn-active" : ""
          }`
        }
        onClick={() => {
          setClickedArrow("right");
          onClick();
        }}
      />
    );
  };

  const SamplePrevArrow = (props: any) => {
    const { className, style, onClick, clickedArrow } = props;
    return (
      <Prev
        className={
          className +
          ` productivity-prev ${
            clickedArrow === "left" ? "carousel-btn-active" : ""
          }`
        }
        onClick={() => {
          setClickedArrow("left");

          onClick();
        }}
      />
    );
  };

  const settings = {
    initialSlide: initialScroll,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          dots: false,
        },
      },
    ],
    nextArrow: <SampleNextArrow clickedArrow={clickedArrow} />,
    prevArrow: <SamplePrevArrow clickedArrow={clickedArrow} />,
  };
  const navLinks = [
    {
      name: "probeme",
      label: "ProbeMe AI",
      url: "/products/AI/probemeai",
    },
    {
      name: "codeme",
      label: "CodeMe AI",
      url: "/products/AI/codemeai",
    },
    {
      name: "data_report",
      label: "Data Reporter",
      url: "/products/AI/datareporter",
    },
    {
      name: "slide",
      label: "SlideManager AI",
      url: "/products/AI/slidemanager",
    },
  ];
  return (
    <Slider {...settings}>
      {navLinks.map((navLink, index) => {
        return (
          <div key={index} className="data-collection-nav px-1">
            <Link
              className={`nav-item ${
                activeNav === navLink.name ? "collection-nav-active" : ""
              }`}
              href={navLink.url}>
              {navLink.label}
            </Link>
          </div>
        );
      })}
    </Slider>
  );
};

export default AIcrousel;
